// extracted by mini-css-extract-plugin
export var h1Typography = "reset-password-module--h1-typography--9TGHs";
export var h2Typography = "reset-password-module--h2-typography--2zcwU";
export var h3Typography = "reset-password-module--h3-typography--ujsZu";
export var h4Typography = "reset-password-module--h4-typography--jcqy2";
export var h5Typography = "reset-password-module--h5-typography--1jt3l";
export var h6Typography = "reset-password-module--h6-typography--1ZJne";
export var pTypography = "reset-password-module--p-typography--2or-4";
export var info = "reset-password-module--info--1YcqM";
export var buttonTypography = "reset-password-module--button-typography--1c_Pf";
export var formLabelTypography = "reset-password-module--form-label-typography--1mFrX";
export var menuTabTypography = "reset-password-module--menu-tab-typography--3l9XC";
export var linkStyle = "reset-password-module--link-style--1AK2J";
export var postTypography = "reset-password-module--post-typography--1gjRI";
export var loginForm = "reset-password-module--login-form--2ZPjH";
export var headerPosition = "reset-password-module--header-position--2kQX1";
export var description = "reset-password-module--description--3ip-a";
export var smallFont = "reset-password-module--small-font--1BP6z";
export var noHrefA = "reset-password-module--no-href-a--1yZza";
export var button = "reset-password-module--button--2N1oG";
export var container = "reset-password-module--container--1cs6A";
export var formButtonContainer = "reset-password-module--form-button-container--yig6C";
export var paragraph = "reset-password-module--paragraph--19Aof";
export var marginBottom0 = "reset-password-module--margin-bottom-0--rKERh";
export var formMargin = "reset-password-module--form-margin--_gX1p";